import React from "react";
import "./VideoSlider.css"; // Import CSS riêng để tùy chỉnh

const VideoSlider = ({ videos }) => {
  return (
    <div className="video-slider">
      <div className="video-grid">
        {videos.map((video, index) => (
          <div key={index} className="video-item">
            <div className="video-frame">
              <iframe
                width="100%"
                height="auto"
                src={`https://www.youtube.com/embed/${video.id}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="video-info">
              <h3>{video.title}</h3>
              <p>{video.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoSlider;
